import { createSlice } from "@reduxjs/toolkit";

export const currentSlice = createSlice({
  name: "current",
  initialState: {},
  reducers: {
    deleteCurrentTask: (state) => {
      for (const key in state) {
        delete state[key];
      }
    },
    setCurrentTask: (state, action) => {
      const task = action.payload;
      state.client = task.client;
      state._id = task._id;
      state.taskname = task.taskname;
      state.cost = task.cost;
      state.duedate = task.duedate;
      state.priority = task.priority;
      state.status = task.status;
      // The composer decides whether to draw itself from this, and it was not
      // copied, so it was always undefined and the cutoff could never hide the
      // box. The send was refused anyway, which is the wrong way round: the
      // client typed a message and then lost it.
      state.updatedTime = task.updatedTime;
      state.workeffort = task.workeffort;
      state.unread = task.unread;
      state.users = task.users;
      state.rating = task.rating;
    },
  },
});

export const { deleteCurrentTask, setCurrentTask } = currentSlice.actions;

export default currentSlice.reducer;
